(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["algolia-autocomplete-default-template"] && !Shopify.designMode) return;
  try {
    
  const initTabSwitcher = function () {
    document.body.addEventListener('click', handleTabClick);
  };

  const handleTabClick = function (e) {
    if (!e.target.matches('.nl__aa-Default-Template__tab-title')) return;

    const clickedTab = e.target.closest('.nl__aa-Default-Template__tab-title');
    const tabsWrapper = e.target.closest('.nl__aa-Default-Template__tabs');

    if (!(clickedTab && tabsWrapper && clickedTab.matches('.active') === false)) return;
    const bodyId = clickedTab.id.replace('tab-head-', 'tab-body-');

    const tabBody = tabsWrapper.querySelector(`#${bodyId}`);
    if (!tabBody) return;

    tabsWrapper
      .querySelectorAll('.nl__aa-Default-Template__tab-body, .nl__aa-Default-Template__tab-title')
      .forEach((tab) => {
        tab.classList.remove('active');
      });
    clickedTab.classList.add('active');
    tabBody.classList.add('active');
  };

  initTabSwitcher();

  } catch(e) { console.error(e); }
})();
})();
